<template>
  <div class="view rtp-monitoring-page">
    <div class="page-header">
      <div>
        <h1 class="page-title">{{ $t('admin.rtp_monitoring.title') }}</h1>
        <p class="page-subtitle">{{ $t('admin.rtp_monitoring.subtitle') }}</p>
      </div>
    </div>
    <RtpMonitoringWidget />
  </div>
</template>

<script setup lang="ts">
import RtpMonitoringWidget from '@/components/admin/RtpMonitoringWidget.vue'
</script>

<style scoped>
.rtp-monitoring-page {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary, #fff);
  margin: 0 0 4px;
}

.page-subtitle {
  font-size: 13px;
  color: var(--text-tertiary, #7f8fa4);
  margin: 0;
}
</style>
